var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7134 17.7991V15.044C29.7134 14.3085 29.125 13.7068 28.3761 13.68H25.7548C24.3105 13.68 22.9866 14.7365 22.8662 16.1808C22.786 17.0234 23.1069 17.8124 23.6686 18.3607C24.1634 18.8689 24.8454 19.1631 25.5944 19.1631H28.3761C29.125 19.1363 29.7134 18.5346 29.7134 17.7991Z",
    stroke: "white",
    strokeWidth: 2.00601,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.96631 18.4277V21.1024C2.96631 24.7399 5.15955 27.2809 8.56978 27.7088C8.91749 27.7623 9.27856 27.7891 9.65302 27.7891H21.6891C22.0368 27.7891 22.3711 27.7757 22.6921 27.7222C26.1425 27.321 28.3758 24.7667 28.3758 21.1024V19.1632H25.5941C24.8452 19.1632 24.1632 18.869 23.6683 18.3608C23.1067 17.8125 22.7857 17.0235 22.866 16.1809C22.9863 14.7366 24.3103 13.6801 25.7546 13.6801H28.3758V11.741C28.3758 7.72893 25.7011 5.05424 21.6891 5.05424H18.3457",
    stroke: "white",
    strokeWidth: 2.00601,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.39258 11.5794C5.39258 13.0255 6.51076 14.1884 7.88238 14.1884H10.6852C11.8779 14.1884 12.847 13.1746 12.847 11.9073C12.847 10.5506 12.2507 10.0587 11.371 9.74557L6.88346 8.18014C6.00384 7.86705 5.4075 7.38997 5.4075 6.01836C5.4075 4.76601 6.37655 3.7373 7.56926 3.7373H10.3721C11.7437 3.7373 12.8619 4.9002 12.8619 6.34635",
    stroke: "white",
    strokeWidth: 2.23633,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.12012 2.26074V15.6787",
    stroke: "white",
    strokeWidth: 2.23633,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletMoney);
export default __webpack_public_path__ + "static/media/wallet-money.dffc87cf.svg";
export { ForwardRef as ReactComponent };